import {DomainEvent} from './DomainEvent';
import {CompetitionSeasonFormStandings} from '../resources';

export class CompetitionSeasonFormStandingsTeasered extends DomainEvent<CompetitionSeasonFormStandings> {}
